<template>
  <div id="unauthorized">
    <div class="container-fluid pt-4">
      <div class="section-title">
        Xml Import Rules
      </div>

      <div class="row">
        <div class="col-lg-12">
          <Rules />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rules from './rules.vue';

export default {
    components: {
        Rules
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/RulesDashboard.vue